<template>
  <div class="app">
    <div class="login-container">
      <div class="slideshow">
        <div class="slideshow-image1"></div>
        <div class="slideshow-image2"></div>
        <div class="slideshow-image3"></div>
        <div class="slideshow-image4"></div>
      </div>
      <div class="dengLu">
        <div class="left masked">
          <div class="left-name">信尔德燃气、电气智能安全监测控制平台</div>
          <div class="left-text">时刻在线 专业高效 安全可靠</div>
        </div>
        <div class="right">
          <div class="admin-form theme-info dLK">
            <h3 class="huanY">欢迎登录</h3>
            <div class="section">
              <div class="section-icon">
                <img src="../../../assets/login/xed-login/user.png" alt="">
              </div>
              <input v-model="LoginCode" class="gui-input input-validation-error" placeholder="请输入用户名" />
            </div>
            <div class="section">
              <div class="section-icon">
                <img src="../../../assets/login/xed-login/password.png" alt="">
              </div>
              <input @keyup.enter="Login" v-model="LoginPassword" @focus="changeInputType" :type="inputType" class="gui-input input-validation-error" placeholder="请输入密码" />
            </div>
            <div class="login-card-input-checkbox">
              <Checkbox v-model="remember">记住密码</Checkbox>
            </div>
            <div @click="Login()" class="btn-primary">登录</div>
          </div>
        </div>
        <Spin fix v-if="loading"></Spin>
      </div>
      <div class="QR-code-div">
        <div class="QR-code-inco">
          <img src="../../../assets/login/QR_code_inco.png" alt="">
        </div>
        <div class="QR-code-text-view">
          <p class="QR-code-text1">扫码下载App</p>
          <p class="QR-code-text2">DownloadApp</p>
        </div>
      </div>
      <div class="QR-code-view">
        <div class="QR-code-view-item">
          <div class="QR-code-view-item-img">
            <img src="../../../assets/login/app_qr_code.png" alt="">
          </div>
          <div class="QR-code-view-item-p">Android 扫码下载</div>
        </div>
        <div class="QR-code-view-item">
          <div class="QR-code-view-item-img">
            <img src="../../../assets/login/wx_qr_code.jpg" alt="">
          </div>
          <div class="QR-code-view-item-p">IOS 微信扫码访问</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../../api/request.js'
  import Cookies from 'js-cookie'
  export default {
    data() {
      return {
        LoginCode: '',
        LoginPassword: '',
        loading: false,
        inputType: 'text',
        remember: true,
        returnCitySN: {},
      }
    },

    computed: {

    },

    mounted() {
      let _this = this;
      let data = Cookies.get('Remember') ? JSON.parse(Cookies.get('Remember')) : '';
      _this.LoginCode = data.LoginCode;
      _this.LoginPassword = data.LoginPassword;
      _this.remember = data.remember;
      if (_this.LoginPassword) {
        _this.inputType = 'password'
      }

      if (_this.$store.getters.getUserState) {
        _this.$Message['error']({
          background: true,
          content: '账号已在别处登录'
        });
      }

      _this.returnCitySN = window.returnCitySN;
      _this.$store.dispatch("setUserState", false);
    },

    methods: {
      changeInputType() {
        this.inputType = 'password'
      },
      Login() {
        let _this = this;

        let data = {
          LoginCode: _this.LoginCode,
          LoginPassword: _this.LoginPassword,
          LoginAddress: _this.returnCitySN.cname,
          Ip: _this.returnCitySN.cip
        }

        if (!data.LoginCode) {
          _this.$Message['error']({
            background: true,
            content: '用户名不能为空'
          });
          return;
        }

        if (!data.LoginPassword) {
          _this.$Message['error']({
            background: true,
            content: '密码不能为空'
          });
          return;
        }
        _this.loading = true;

        api({
          //这里是你自己的请求方式、url和data参数
          method: 'post',
          url: 'api/User/UserLogin',
          data: data,
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
          }
        }).then(function(res) {
          _this.loading = false;
          if (res.Success) {
              
            // 是否记住密码
            if (_this.remember) {
              Cookies.set('Remember', {
                remember: true,
                ...data
              });
            } else {
              Cookies.set('Remember', {
                LoginCode: _this.LoginCode,
                LoginPassword: '',
                remember: false
              });
            }

            // 储存后台返回位置
            Cookies.set('cityName', res.Data.AddressName);

            // 保存token
            Cookies.set('Token', res.Data.token_type + ' ' + res.Data.access_token);

            // 保存集团部门编号
            Cookies.set('AdminData', {
              GroupCode: res.Data.GroupCode,
              CompanyCode: res.Data.CompanyCode,
              DepartmentCode: res.Data.DepartmentCode,
              IsAdmin: res.Data.IsAdmin,
              TittleName: res.Data.TittleName,
              TittleNameEN: res.Data.TittleNameEN,
              ImageUrl: res.Data.ImageUrl
            });

            // 保存登录名
            Cookies.set('UserLogin', res.Data.UserInfo.UserLogin);

            _this.$store.dispatch("setCodeValue",
              `${res.Data.GroupCode}${res.Data.CompanyCode}${res.Data.DepartmentCode}`);
            _this.$router.push({
              name: 'home'
            })
          } else {
            _this.$Message['error']({
              background: true,
              content: res.Message
            });
          }
        }).catch(function(err) {
          _this.loading = false;
          console.log(err);
        });

        // _this.$router.push({name: 'home'})
      },
    }
  }
</script>

<style scoped="scoped">
  @import url("./xed_login.css");
</style>



// WEBPACK FOOTER //
// src/components/login/xed_login/xed_login.vue